<div class="app-network-admin-studio w-100">

    <div class="row">
        <div class="col-12 col-md-6">
            <h2 class="waiting-room">
                <a role="button" class="back-button" (click)="goBack()"><i class="fa fa-chevron-circle-left"
                        aria-hidden="true"></i></a>
                {{roomInfo?.name}} 
                /  {{subRoomNameNew}}
            </h2>
        </div>
        <div class="col-12 col-md-6 text-right">
            <!-- <a role="button" (click)="disconnect()" class="leave-btn pointer" matTooltipPosition="above"
                matTooltip="Leave room">
                <i class="fa fa-sign-out" aria-hidden="true"></i>
            </a> -->
        </div>
    </div>

    <!-- <div fxFlex="100%" fxLayout="row wrap" fxLayoutAlign="start start"> -->
    <a (click)="expand()" class="top-icon pointer" role="button" [ngClass]="isExpand ? 'collapseIcon' : 'expandIcon'">
        <!-- <img [src]="(isExpand)? assets_url + 'stream-icons/collapse.svg':assets_url + 'stream-icons/expand.svg'" id="expandButton" /> -->
        <span id="expandButton"><app-svg [icon]="(isExpand)? 'collapse':'expand'"></app-svg></span>
    </a>
    <div class="w-100 row " id="videoWrapper" [ngClass]="!isExpand ? 'video-room plr-50' : 'plr-10'">
    </div>
    <!-- </div> -->
    <div class="list w-100 mt-4">
        <ng-container *ngIf="(subRoomData && subRoomData?.length > 0) && !isExpand">
            <div class="room-container">
                <div class="row no-gutters">
                    <div class="col-12 col-md-3 pointer" *ngFor="let room of subRoomData">
                        <div class="box-style">
                            <div class="col-12">
                              <p class="fs-20 text-center text-capitialize" *ngIf="room?.room && room?.room.length <= 30">
                                    {{room?.room}} </p>
                                <p class="text-center" *ngIf="room?.room && room?.room.length > 30"
                                    matTooltipPosition="above" matTooltip="{{room?.room}}">
                                    {{room?.room | slice: 0:30}}
                                    {{room?.room.length > 30 ? "..." : ""}}
                                </p>
                            </div>
                            <div class="circle-container-main">
                                <!-- <span class="circle-container-add pointer"
                                        (click)="showParticipants(r.id)"> <i
                                            class="fa fa-plus fs-18 plus-icon text-info" aria-hidden="true"></i> </span> -->
                                <div>
                                    <ul class='circle-container'>
                                        <li *ngFor="let p of room.participants" matTooltipPosition="above"
                                            matTooltip="{{p?.name}}">
                                            <div class="roundIcon text-center ml-1"
                                                [ngStyle]="{'background-color': p?.userColor }">
                                                <span class="text-uppercase notranslate">{{p?.shortName}}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="w-100 relative mt-40">
        <div class="v-controls-div">
            <div class="v-controls">
                <a class="c-icons" (click)="soundOff()">
                    <!-- <img [src]="assets_url + 'stream-icons/mic-hover.svg'"
                        [matTooltip]="(!soundStatus)?'Unmute Audio':'Mute Audio'" matTooltipPosition="above"
                        id="audioButton" /> -->
                    <span [matTooltip]="(!soundStatus)?'Unmute Audio':'Mute Audio'" matTooltipPosition="above" id="audioButton"><app-svg [icon]="audio_Icon"></app-svg></span>
                </a>
                <a class="c-icons" (click)="vidOff()">
                    <!-- <img [src]="assets_url + 'stream-icons/video-hover.svg'"
                        [matTooltip]="(!vidStatus)?'Play Video':'Pause Video'" matTooltipPosition="above"
                        id="videoButton" /> -->
                        <span [matTooltip]="(!vidStatus)?'Play Video':'Pause Video'" matTooltipPosition="above" id="videoButton"><app-svg [icon] = "video_Icon"></app-svg></span>
                </a>
            </div>
            <button (click)="leaveRoom()" class="btn leave-room"> Leave Room</button>
        </div>
    </div>
</div>